var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCkFalse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 0H1.16667C0.857247 0 0.560501 0.131696 0.341709 0.366116C0.122916 0.600537 0 0.918479 0 1.25V13.75C0 14.0815 0.122916 14.3995 0.341709 14.6339C0.560501 14.8683 0.857247 15 1.16667 15H12.8333C13.1428 15 13.4395 14.8683 13.6583 14.6339C13.8771 14.3995 14 14.0815 14 13.75V1.25C14 0.918479 13.8771 0.600537 13.6583 0.366116C13.4395 0.131696 13.1428 0 12.8333 0ZM1.16667 13.75V1.25H12.8333V13.75H1.16667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkFalse);
export default __webpack_public_path__ + "static/media/ck_false.1a6ecac8be3d8672b91d9de01d06894b.svg";
export { ForwardRef as ReactComponent };